module.exports = __webpack_public_path__ + "img/cover_3.a21549a3.png";